import { Bars } from "@Components/forecast/Bars";
import { HourProps } from "@Components/forecast/hourly/ItemWrapper";
import { BarsLabel } from "@Components/forecast/label/BarsLabel";
import { HourLabel } from "@Components/forecast/label/HourLabel";
import { useTranslations } from "@Context/TranslationContext/TranslationContext";

export const SnowItem = ({
  intervalType,
  label,
  hour,
  boldLabel,
  withDivider,
}: HourProps & { boldLabel: boolean; withDivider: boolean }) => {
  const { t } = useTranslations();
  const { FRESHSNOW_MM: snowAmount } = hour;
  const snowAmountInCm = snowAmount ? snowAmount / 10 : 0.0;
  const barScalingFactor = intervalType === "1h" ? 9 : 3;

  return (
    <>
      <span
        className="m:sr-only m:h-[114px]! m:w-[64px]! m:lg:w-[80px]!"
        aria-label={t("navigation.a11ySnowLabel", {
          label: label,
          snowAmountInCm,
        })}
        tabIndex={-1}
      />
      <div
        className="m:mt-2 m:flex m:flex-col m:items-center"
        aria-hidden="true"
        role="presentation">
        <HourLabel
          label={label}
          isBold={boldLabel}
          testId="hourly-navigation-snow-item-hour"
        />
      </div>
      <div
        className="m:mt-1 m:flex m:flex-col"
        aria-hidden="true"
        role="presentation">
        <div className="m:relative">
          <Bars
            values={[snowAmountInCm || 0]}
            unit="cm"
            scalingFactor={barScalingFactor}
            barBackgroundColorClassName="m:bg-special-snow-bar"
            withDivider={withDivider}
          />
        </div>
        <BarsLabel
          topLabel={{
            value: snowAmountInCm.toFixed(1),
            className: "m:mt-2",
            testId: "hourly-navigation-snow-item-amount",
          }}
          bottomLabel={{
            value: "cm",
          }}
        />
      </div>
    </>
  );
};
